import { useEffect, useState } from 'react';
import { Box, Grid, SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/system';
import { styles } from './styles';

export const MentionIndicator = ({ sx, hide }: { sx?: SxProps<Theme>; hide?: boolean }) => {
  const [show, setShow] = useState(!hide);
  const [shouldRender, setShouldRender] = useState(!hide);

  useEffect(() => {
    if (!hide) {
      setShouldRender(true);
      setTimeout(() => setShow(true), 10);
    } else {
      setShow(false);
      const timeout = setTimeout(() => setShouldRender(false), 250);
      return () => clearTimeout(timeout);
    }
  }, [hide]);

  if (!shouldRender) return null;

  return (
    <Grid
      sx={{
        ...styles.root(show),
        ...sx,
      }}
    >
      <Grid sx={styles.container}>
        <Typography sx={styles.text}>Use</Typography>
        <Box sx={styles.iconBox}>@</Box>
        <Typography sx={styles.text}>to mention teammates, and</Typography>
        <Box sx={styles.iconBox}>#</Box>
        <Typography sx={styles.text}>to reference files, schedules, or selection items.</Typography>
      </Grid>
    </Grid>
  );
};
